export const defaultQuickLinksItemsFactory = (intl) => {
    const { $t } = intl;
    return [
        {
            title: $t({
                id: 'Blocks.QuickLinks.DefaultQuickLinkTitleNum',
                defaultMessage: 'Quick link #{num}',
            }, { num: 1 }),
            description: '',
            action: {
                text: $t({
                    id: 'Blocks.QuickLinks.DefaultActionText',
                    defaultMessage: 'Quick link',
                }),
                href: '#',
            },
            image: {
                id: ':heart_eyes:',
                text: 'heart_eyes',
            },
        },
        {
            title: $t({
                id: 'Blocks.QuickLinks.DefaultQuickLinkTitleNum',
                defaultMessage: 'Quick link #{num}',
            }, { num: 2 }),
            description: '',
            action: {
                text: $t({
                    id: 'Blocks.QuickLinks.DefaultActionText',
                    defaultMessage: 'Quick link',
                }),
                href: '#',
            },
            image: {
                id: ':yum:',
                text: 'yum',
            },
        },
    ];
};
//# sourceMappingURL=constants.js.map